import { parseDefiniteProductDTO, ProductDTO } from './product-dto.js'
import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

// --- Variant Filter ---

export type IVariantFilterDTO = {
  value: string
  description: string | null
  picture: unknown
  css_color?: string | null
  matching_products: number[]
}

export class VariantFilterDTO {
  value: string
  description: string | null
  picture: unknown
  cssColor: string | null | undefined
  matchingProducts: number[]

  constructor(data: IVariantFilterDTO) {
    this.value = data.value
    this.description = data.description
    this.picture = data.picture
    this.cssColor = data.css_color
    this.matchingProducts = data.matching_products
  }
}

const validateVariantFilterDTO = createValidate<IVariantFilterDTO>()

export const parseVariantFilterDTO = (data: unknown): VariantFilterDTO => {
  validateGuard(validateVariantFilterDTO, data, 'VariantFilterDTO')
  return new VariantFilterDTO(data)
}

// --- Variant Data ---

export type IVariantDataDTO = {
  variants: unknown[]
  filters: unknown[] | null
}

export class VariantDataDTO {
  variants: ProductDTO[]
  filters: VariantFilterDTO[] | null

  constructor(data: IVariantDataDTO) {
    this.variants = data.variants.map(parseDefiniteProductDTO)
    this.filters = data.filters?.map(parseVariantFilterDTO) ?? null
  }
}

const validateVariantDataDTO = createValidate<IVariantDataDTO>()

export const parseVariantDataDTO = (data: unknown): VariantDataDTO | null => {
  if (data === null) return null
  validateGuard(validateVariantDataDTO, data, 'VariantDataDTO')
  return new VariantDataDTO(data)
}
